﻿import $ from 'jquery';
import 'slick-carousel';

class StockSliderItem {
    constructor(el, index) {
        this.render(el, index);
        
    }


    render(el, i) {

        var $slider = $('.c-stocksearch__details-slider');
        var $thumbs = $('.c-stocksearch__details-thumb');

        if ($slider.length > 0) {
            $slider.slick({
                arrows: true,
                appendArrows: '.c-stocksearch__details-slider-nav',
                asNavFor: '.c-stocksearch__details-thumb',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                adaptiveHeight: false
            });
        }

        if ($thumbs.length > 0) {
            $thumbs.slick({
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.c-stocksearch__details-slider',
                focusOnSelect: true,
                centerMode: false,
                centerPadding: '40px',
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 5
                        }
                    }
                ]
            });
        }
    }
}



class StockSlider {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }
    
    render(el, index) {
        new StockSliderItem(el, index);
    }
}

export default StockSlider;